import axios from '../config/axios';
import config from '../config/index';
import { notification } from 'antd';
import {getResponseHandler,header} from './commonService'

const Address = {
    getAddressList : async (data = {}) => {
        try{
            let rowData;
            if(data?.paramID>0){
                 rowData = await axios.get('/address/'+data?.paramID)
            }else{
                 rowData = await axios.post('/address/getlist',data )
            }
            
            const response = await rowData;
            return getResponseHandler(response);               
        }catch (error){
            console.error(error);
            notification.error({ message: error.message, placement:'bottomRight' });
        }
    }, 
    addAddress : async (data={}) =>{
        try{
            const rowData = await axios.post('/address',data)
            const response = await rowData;
            return getResponseHandler(response);               
        }catch (error){
            console.error(error);
            notification.error({ message: error.message, placement:'bottomRight' });
        }
    }, 
    updateAddress : async (id, data={}) =>{
        try{
            const rowData = await axios.patch('/address/'+id,data)
            const response = await rowData;
            return getResponseHandler(response);               
        }catch (error){
            console.error(error);
            notification.error({ message: error.message, placement:'bottomRight' });
        }
    } ,
    deleteAddress: async (id) => {
        try{
            const rowData = await axios.delete('/address/'+id)
            const response = await rowData;
            return getResponseHandler(response);               
        }catch (error){
            console.error(error);
            notification.error({ message: error.message, placement:'bottomRight' });
        }
    },

    
                           
    
}


export default Address